// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/card/card';
import 'snippets/pagination/pagination';

import 'sections/page-header/page-header';
import 'sections/footer/footer';


// Styles
import './_collection.scss';

document.addEventListener('DOMContentLoaded', function() {
// Check if the body ID is "buy-with-prime"
if (document.body.id === 'buy-with-prime') {
    // Check if the URL contains specific locale segments
    var currentPath = window.location.pathname;
    var localeSegments = ['/en-ca', '/en-uk', '/en-eu'];
    var localeSegment = localeSegments.find(segment => currentPath.includes(segment));

    if (localeSegment) {
    // Hide the entire main content if conditions are met
    var mainContent = document.querySelector('.page-section--main-collection');
    if (mainContent) {
        mainContent.style.display = 'none'; // Hides the element
    }

    // Redirect to homepage while maintaining the locale segment
    var redirectUrl = localeSegment + '/';
    window.location.href = redirectUrl; // Redirects to the homepage with locale segment
    }
}
});
